<template>
<div class="chapter">
<div class="inner_page">
<section class="div_autre" epub:type="preamble">
<div class="pre" id="pre-003"><span epub:type="pagebreak" id="page_XV" role="doc-pagebreak" title="XV">
<h1 class="pre_tit" epub:type="title"><span>Abbreviations</span></h1>
<div class="dev">
<div class="tableau" id="tableau-001">
<div class="table-align">
<table style="border-collapse:collapse; border-spacing:0px;">
<colgroup style="padding:1px;">
<col style="padding:1px;"/>
<col style="width:83.25%;"/>
</colgroup>
<tbody>
<tr style="padding:1px;">
<td style="padding:1px;"><p class="txt_courant_ssalinea">AAP</p></td>
<td style="padding:1px;"><p class="txt_courant_ssalinea">American Academy of Pediatrics</p></td>
</tr>
<tr style="padding:1px;">
<td style="padding:1px;"><p class="txt_courant_ssalinea">APA</p></td>
<td style="padding:1px;"><p class="txt_courant_ssalinea">American Psychological Association</p></td>
</tr>
<tr style="padding:1px;">
<td style="padding:1px;"><p class="txt_courant_ssalinea">ASD</p></td>
<td style="padding:1px;"><p class="txt_courant_ssalinea">autism spectrum disorder</p></td>
</tr>
<tr style="padding:1px;">
<td style="padding:1px;"><p class="txt_courant_ssalinea">DBT</p></td>
<td style="padding:1px;"><p class="txt_courant_ssalinea">dialectical behavior therapy</p></td>
</tr>
<tr style="padding:1px;">
<td style="padding:1px;"><p class="txt_courant_ssalinea"><i>DSM</i></p></td>
<td style="padding:1px;"><p class="txt_courant_ssalinea">American Psychiatric Association, <i>Diagnostic and Statistical Manual of Mental Disorders</i></p></td>
</tr>
<tr style="padding:1px;">
<td style="padding:1px;"><p class="txt_courant_ssalinea">GCS</p></td>
<td style="padding:1px;"><p class="txt_courant_ssalinea">gender-confirmation surgery</p></td>
</tr>
<tr style="padding:1px;">
<td style="padding:1px;"><p class="txt_courant_ssalinea">GICE</p></td>
<td style="padding:1px;"><p class="txt_courant_ssalinea">gender-identity-change efforts</p></td>
</tr>
<tr style="padding:1px;">
<td style="padding:1px;"><p class="txt_courant_ssalinea">GRIT</p></td>
<td style="padding:1px;"><p class="txt_courant_ssalinea">Gender and Religious Identity Therapy</p></td>
</tr>
<tr style="padding:1px;">
<td style="padding:1px;"><p class="txt_courant_ssalinea">HT</p></td>
<td style="padding:1px;"><p class="txt_courant_ssalinea">hormone therapy</p></td>
</tr>
<tr style="padding:1px;">
<td style="padding:1px;"><p class="txt_courant_ssalinea">LGBTQ+</p></td>
<td style="padding:1px;"><p class="txt_courant_ssalinea">lesbian, gay, bisexual, transgender, queer, and other</p></td>
</tr>
<tr style="padding:1px;">
<td style="padding:1px;"><p class="txt_courant_ssalinea">SAMHSA</p></td>
<td style="padding:1px;"><p class="txt_courant_ssalinea">Substance Abuse and Mental Health Services Administration</p></td>
</tr>
<tr style="padding:1px;">
<td style="padding:1px;"><p class="txt_courant_ssalinea">SOCE</p></td>
<td style="padding:1px;"><p class="txt_courant_ssalinea">sexual-orientation-change efforts</p></td>
</tr>
<tr style="padding:1px;">
<td style="padding:1px;"><p class="txt_courant_ssalinea">WPATH</p></td>
<td style="padding:1px;"><p class="txt_courant_ssalinea">World Professional Association for Transgender Health</p></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre4.vue?2b8d84c8